import { IResubmittedDocumentsResponse } from "../../utils/types";
import { apiManager } from "../api-manager";

export const getResubmittedDocuments = async (id: string) => {
  const res = await apiManager.get<IResubmittedDocumentsResponse>(
    `/admin/resubmit/${id}`
  );
  return res;
};
